import { Alert, Card, CardContent, CardHeader, CardTitle, LoadingSpinner, QueryErrorAlert } from '@shared/components';
import type { RollUpModel } from '../../../hooks/useFundStatementPeriodSection';
import { NOT_ENTITLED_MESSAGE, unavailableMessage, unverifiedMessage } from '../../../utils/fundStatementLabels';
import { PeriodStatementBody } from './PeriodStatementBody';

function RollUpBody({ state, periodLabel, statement, layout, onRetry }: RollUpModel) {
    if (state === 'loading') return <LoadingSpinner message="Loading fund statement" />;
    if (state === 'error') {
        return <QueryErrorAlert variant="error" message={unavailableMessage(periodLabel)} onRetry={onRetry} />;
    }
    if (state === 'unverified') {
        return <QueryErrorAlert variant="warning" message={unverifiedMessage(periodLabel)} onRetry={onRetry} />;
    }
    if (state === 'not_entitled') return <Alert variant="info" role="note">{NOT_ENTITLED_MESSAGE}</Alert>;
    if (!statement || !layout) return null;
    return (
        <PeriodStatementBody statement={statement} layout={layout} />
    );
}

export function RollUpStatementCard(props: RollUpModel) {
    return (
        <Card ariaLabelledBy="fund-statement-roll-up-heading">
            <CardHeader>
                <CardTitle id="fund-statement-roll-up-heading">Fund Statement</CardTitle>
                {props.datesLine && <p className="text-sm text-mp-muted">{props.datesLine}</p>}
                <p className="text-sm text-mp-muted">{props.summary}</p>
            </CardHeader>
            <CardContent>
                <RollUpBody {...props} />
            </CardContent>
        </Card>
    );
}
